import { DriversType, CategoriesType } from "@/types/settings/drivers";
import { PhoneNumberType } from "@/types/customer/customer.type";
import PhoneModule from "../phone";
import Storage from "@/services/storage";
import { StorageConstants } from "@/enums/storage.enum";
import DriversInterface from "@/interface/business/drivers.interface";

class Drivers implements DriversInterface {
  id: string = "";
  name: string = "";
  phone: number | PhoneNumberType = 0;
  phone_number: PhoneNumberType = new PhoneModule();
  categories?: Array<CategoriesType> = [];
  created_at?: string = "";
  updated_at?: string = "";
  teams?: Array<any>;
  locations?: Array<any> = [];
  locationsNames?: Array<string>;
  selected?: boolean = false;
  status: boolean = true;

  public static module_name = "delivery/driver";

  constructor(data?: DriversType) {
    if (data) {
      this.id = data.id;
      this.name = data.name || "";
      this.phone_number = new PhoneModule({
        number: data.phone_number,
      });
      this.phone = data.phone_number || 0;
      this.categories = data?.categories || [];
      this.created_at = data?.created_at || "";
      this.updated_at = data?.updated_at || "";
      this.teams = data?.categories?.map((category) => category.name) || [];
      this.status = data?.status ?? true;
      this.prepareLocations(data);
    }
  }

  /**
   * map the locations name to the location id
   * @param data
   * @private
   */
  private prepareLocations(data) {
    const locationsList = Storage.get(StorageConstants.LOCATIONS);
    this.locations = data.locations.flatMap((id) => locationsList.find((location) => location.id === id));
    this.locationsNames = this.locations?.flatMap((i) => i.name);
  }

  /**
   * prepare locations and phone number to be sent to back end
   * @param form
   * @return driver
   */
  public prepareFormBody(form): DriversType {
    this.locations = form.locations.map((location) => location.id);
    this.phone_number = form.phone_number.getInternational() || form.phone;
    this.categories = form.categories || [];
    return this;
  }
}

export default Drivers;
